import customerIdRegex from '@eneco/common/validation/customerIdRegex';
import { emailValidation } from '@eneco/common/validation/emailRegex';
import phoneNumberRegex from '@eneco/common/validation/phoneNumberRegex';
import { boolean, object, string } from 'yup';

import type { ContactFormFields } from '../contact-form-content.types';

export const getSchema = (
  formFields: ContactFormFields,
  hideInquiryTypeFormFieldCheckbox: boolean | undefined,
  canHaveBudgetManager: boolean,
) => {
  const {
    salutationFormField,
    firstNameFormField,
    surnameFormField,
    phoneNumberFormField,
    emailAddressFormField,
    customerIdFormField,
    inquiryTopicFormField,
    inquiryTypeFormField,
    inquiryContentFormField,
    businessNameFormField,
    cityFormField,
    houseNumberFormField,
    postalCodeFormField,
    streetNameFormField,
  } = formFields;

  return object({
    recaptchaToken: string().required(),
    inquiryTopic: string().required(inquiryTopicFormField.requiredMessage),
    inquiryType: !hideInquiryTypeFormFieldCheckbox ? string().required(inquiryTypeFormField.requiredMessage) : string(),
    inquiryContent: string().required(inquiryContentFormField.requiredMessage),
    salutation: string().required(salutationFormField.requiredMessage),
    firstName: string().required(firstNameFormField.requiredMessage),
    surnamePreposition: string(),
    surname: string().required(surnameFormField.requiredMessage),
    phoneNumber: string()
      .matches(phoneNumberRegex, { message: phoneNumberFormField.validationMessage })
      .required(phoneNumberFormField.requiredMessage),
    emailAddress: emailValidation({
      emailMessage: emailAddressFormField?.validationMessage,
      requiredMessage: emailAddressFormField?.requiredMessage,
    }),
    customerId: string()
      .optional()
      .matches(customerIdRegex, { message: customerIdFormField.validationMessage, excludeEmptyString: true }),
    ...(canHaveBudgetManager ? { authorIsBudgetManager: boolean() } : {}),
    budgetManagerBusiness: string().when('authorIsBudgetManager', ([authorIsBudgetManager]) =>
      authorIsBudgetManager ? string().required(businessNameFormField.requiredMessage) : string(),
    ),
    budgetManagerSalutation: string().when('authorIsBudgetManager', ([authorIsBudgetManager]) =>
      authorIsBudgetManager ? string().required(salutationFormField.requiredMessage) : string(),
    ),
    budgetManagerFirstname: string().when('authorIsBudgetManager', ([authorIsBudgetManager]) =>
      authorIsBudgetManager ? string().required(firstNameFormField.requiredMessage) : string(),
    ),
    budgetManagerSurnamePreposition: string(),
    budgetManagerSurname: string().when('authorIsBudgetManager', ([authorIsBudgetManager]) =>
      authorIsBudgetManager ? string().required(surnameFormField.requiredMessage) : string(),
    ),
    budgetManagerEmailAddress: string().when('authorIsBudgetManager', ([authorIsBudgetManager]) =>
      authorIsBudgetManager
        ? string().email(emailAddressFormField.validationMessage).required(emailAddressFormField.requiredMessage)
        : string().email(),
    ),
    budgetManagerPhoneNumber: string().when('authorIsBudgetManager', ([authorIsBudgetManager]) =>
      authorIsBudgetManager
        ? string()
            .matches(phoneNumberRegex, {
              excludeEmptyString: true,
              message: phoneNumberFormField.validationMessage,
            })
            .required(phoneNumberFormField.requiredMessage)
        : string(),
    ),
    budgetManagerPostalCode: string().when('authorIsBudgetManager', ([authorIsBudgetManager]) =>
      authorIsBudgetManager ? string().required(postalCodeFormField.requiredMessage) : string(),
    ),
    budgetManagerHouseNumber: string().when('authorIsBudgetManager', ([authorIsBudgetManager]) =>
      authorIsBudgetManager ? string().required(houseNumberFormField.requiredMessage) : string(),
    ),
    budgetManagerHouseNumberSuffix: string(),
    budgetManagerStreetName: string().when('authorIsBudgetManager', ([authorIsBudgetManager]) =>
      authorIsBudgetManager ? string().required(streetNameFormField.requiredMessage) : string(),
    ),
    budgetManagerCity: string().when('authorIsBudgetManager', ([authorIsBudgetManager]) =>
      authorIsBudgetManager ? string().required(cityFormField.requiredMessage) : string(),
    ),
  });
};
